module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@2x-0759a1bbb32f37f36359cbe24fbf729a.png";